import React, { useState, useEffect } from "react";
import { getMarketData } from "../services/api";
import CryptoCard from "./CryptoCard";

export const MarketTrend = () => {
  const [coined, setCoined] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getMarketData();
        setCoined(data || []);
      } catch (error) {
        console.error("Failed to load:", error);
        setCoined([]);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="bg-gradient-to-b from-violet-900 to-gray-900 py-10 px-4">
      <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8">
        Market Trend
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {coined.length > 0 ? (
          coined.map((coin, index) => (
            <CryptoCard
              key={index}
              name={coin.name}
              symbol={coin.symbol}
              price={coin.current_price}
              change={coin.price_change_percentage_24h}
              sparkline_in_7d={coin.sparkline_in_7d} 
            />
          ))
        ) : (
          <p className="text-white text-center">Loading market data...</p>
        )}
      </div>
    </section>
  );
};